import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-51d03e61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "video-container" }
const _hoisted_3 = { class: "video-title" }
const _hoisted_4 = { class: "video-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "video-close-icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.close('0')))
      }),
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.popInfo.title), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.popInfo.detail), 1),
      _createElementVNode("div", {
        class: "video-close-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.close('1')))
      }, "继续学习")
    ])
  ], 512)), [
    [_vShow, $props.visible]
  ])
}